let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("54RZ3")).then(() => parcelRequire('3QY0x'));